import React from 'react';
import { ButtonLink } from '../common';
import { ITealiumConfig } from '../../utils/models';

import './ShopBannerCTA.scss';
import { KiteButton } from '@kite/react-kite';

export interface IShopBannerCTAProps {
  className?: string;
  title: string;
  linkText?: string;
  linkPath?: string;
  tealiumConfig?: ITealiumConfig;
  onClick?: any;
  type?: 'button' | 'link';
  fontSize?: string;
}

const ShopBannerCTA = ({
  className,
  title,
  linkText = `Shop Spectrum's Plans`,
  linkPath,
  tealiumConfig,
  onClick,
  type,
  fontSize
}: IShopBannerCTAProps) => {
  const displayButton = () => {
    if (type === 'button') {
      return (
        <KiteButton
          className="shop-banner__link"
          onClick={onClick}
          legacy
          size="lg"
        >
          {linkText}
        </KiteButton>
      );
    }

    return (
      <ButtonLink
        className="shop-banner__link"
        type="primary"
        path={linkPath!}
        rel="noreferrer"
        target="_blank"
        tealiumConfig={tealiumConfig}
        onClick={onClick}
      >
        {linkText}
      </ButtonLink>
    );
  };

  const style = fontSize ? { fontSize } : {};

  return (
    <section className={`shop-banner ${className || ''}`}>
      <div className="shop-banner__inner">
        <h2 className="shop-banner__title" style={style}>{title}</h2>
        {displayButton()}
      </div>
    </section>
  );
};

export default ShopBannerCTA;
